/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum RouteTimelineEventException {
  DELIVERY_ISSUE="DELIVERY_ISSUE"
}

/**
* RouteTimelineEventException
 *
 * Exception indicator for a route timeline event
*/
export const RouteTimelineEventExceptionEnumType = types.enumeration("RouteTimelineEventException", [
        "DELIVERY_ISSUE",
      ])
